<template>
  <div>
    <v-dialog v-model="setUpSignDialog" max-width="450">
      <v-card style="border-radius: 1em;">
        <v-card-title>
          <v-spacer></v-spacer>
          <span class="w-700 font-18 text-333333">ออกใบรับรองแพทย์</span>
          <v-spacer></v-spacer>
          <v-icon @click="setUpSignDialog = false" color="#029ED7"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="mt-5">
          <center>
            <v-img width="160" src="@/assets/img/profile/setup-signature.svg" />
          </center>
        </v-card-text>
        <v-card-text class="text-center">
          <p class="w-600 font-16 text-333333">คุณยังไม่ตั้งค่าลายเซ็น</p>
          <p class="font-14 text-333333">
            คุณสามารถสร้างลายเซ็นอิเล็กทรอนิกกับทางเราได้ <br />
            หากคุณต้องการ กดปุ่มดำเนินการต่อ
          </p>
        </v-card-text>
        <v-card-actions class="center pb-6">
          <v-btn @click="setUpSignDialog = false" outlined color="#029ED7"
            >ยกเลิก</v-btn
          >
          <v-btn @click="continueSign()" dark color="#029ED7" width="120"
            >ดำเนินการต่อ</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AddSignature ref="AddSignature" @signed="signed"/>
  </div>
</template>

<script>
import AddSignature from "./AddSignature.vue";
export default {
  name: "setUpSignDialog",
  components: {
    AddSignature
  },
  data() {
    return {
      setUpSignDialog: false
    };
  },
  methods: {
    open() {
      this.setUpSignDialog = true;
    },
    continueSign() {
      this.setUpSignDialog = false;
      this.$refs.AddSignature.open("fromDigitalCert");
    },
    signed() {
      this.$emit("Approve");
    }
  }
};
</script>

<style scoped>
.v-btn {
  width: 120px;
  border-radius: 0.7em;
}
</style>
